import React from 'react';
//, {useState, useEffect}
import { Route, Routes, useParams } from "react-router-dom";
import { Container } from 'react-bootstrap';

import ExperimentForm from './ExperimentForm';
import ExperimentFormAsync from './ExperimentFormAsync';
import ExperimentList from './ExperimentList';
import ExperimentDetail from './ExperimentDetail';
import NotFound from '../../components/NotFound';
import LeftNav from '../../components/LeftNav';

const Experiments = () => {

    let {accountKey} = useParams();
    return (
        <Container fluid>
            <LeftNav accountKey={accountKey}/>
            <Routes>
                <Route path="/create" element={<ExperimentFormAsync />} />
                {/*<Route path="/createasync" element={<ExperimentFormAsync />} />*/}
                {/*<Route path="/detail/:experimentId" element={<ExperimentDetail />} />*/}
                <Route path="/" element={<ExperimentList />} exact={true} />
                {/*<Route path="/" element={<ExperimentForm />} exact={true} />*/}
                <Route path="*" element={<NotFound />} />
            </Routes>

        </Container>
    )
}

export default Experiments;
